"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_accessibility_1 = require("owa-accessibility");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var styles = require('./ToggleFavoriteButton.scss');
var classNames = require('classnames/bind').bind(styles);
var SPINNER_TIMEOUT = 2000; //ms
var spinnerTimer = null;
var ToggleFavoriteButton = /** @class */ (function (_super) {
    tslib_1.__extends(ToggleFavoriteButton, _super);
    function ToggleFavoriteButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSpinner: false,
        };
        return _this;
    }
    // We want to show the spinner only 2 seconds after the favorite action if clickDisabled is still true
    ToggleFavoriteButton.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (!this.props.isClickDisabled && nextProps.isClickDisabled) {
            spinnerTimer = setTimeout(function () {
                _this.setState({
                    showSpinner: true,
                });
            }, SPINNER_TIMEOUT);
        }
        if (this.props.isClickDisabled && !nextProps.isClickDisabled) {
            if (this.state.showSpinner) {
                this.setState({
                    showSpinner: false,
                });
            }
            if (spinnerTimer) {
                clearTimeout(spinnerTimer);
                spinnerTimer = null;
            }
        }
    };
    ToggleFavoriteButton.prototype.componentWillUnmount = function () {
        if (spinnerTimer) {
            clearTimeout(spinnerTimer);
            spinnerTimer = null;
        }
    };
    ToggleFavoriteButton.prototype.render = function () {
        var _this = this;
        var favoriteIcon = this.props.isInFavorites
            ? "FavoriteStarFill" /* FavoriteStarFill */
            : "FavoriteStar" /* FavoriteStar */;
        var favoriteIconClassNames = classNames(this.props.className ? this.props.className : styles.favoriteIcon, styles.favoriteIconBase, this.props.animate && this.props.isInFavorites ? styles.saved : undefined);
        var tooltip = this.props.isInFavorites
            ? owa_mail_strings_1.default.removeFromFavoritesText
            : owa_mail_strings_1.default.addToFavoritesText;
        var shouldHideFromAccessibilityTree = this.props.isWrappedInAnotherButton;
        var ariaProps = shouldHideFromAccessibilityTree
            ? {
                role: owa_accessibility_1.AriaRoles.presentation,
                hidden: true,
            }
            : {
                role: undefined,
                label: owa_mail_strings_1.default.favoriteCharmAriaLabelText,
                pressed: this.props.isInFavorites,
            };
        var buttonClassNames = classNames(styles.container, this.props.isClickDisabled && styles.clickDisabled);
        return this.state.showSpinner && this.props.isClickDisabled ? (React.createElement("div", tslib_1.__assign({ className: styles.spinnerContainer, tabIndex: shouldHideFromAccessibilityTree ? -1 : undefined, title: tooltip }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
            React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small }),
            React.createElement("div", { className: styles.spinnerText }, this.props.text))) : (React.createElement(Button_1.ActionButton, tslib_1.__assign({ className: buttonClassNames, onClick: function (event) { return !_this.props.isClickDisabled && _this.props.onClick(event); }, tabIndex: shouldHideFromAccessibilityTree ? -1 : undefined, iconProps: {
                iconName: favoriteIcon,
                styles: {
                    root: favoriteIconClassNames,
                },
            }, text: this.props.text, title: tooltip, styles: this.props.styles }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps))));
    };
    ToggleFavoriteButton = tslib_1.__decorate([
        mobx_react_1.observer
    ], ToggleFavoriteButton);
    return ToggleFavoriteButton;
}(React.Component));
exports.default = ToggleFavoriteButton;
//# sourceMappingURL=ToggleFavoriteButton.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-favorites/lib/components/ToggleFavoriteButton.js
// module id = 2330
// module chunks = 46 105